import { CrossTreeSelector } from "axe-core";

export enum ValidationMessageImpact {
    Error = "error",
    Warning = "warning",
    Notice = "notice",
    Unknown = "unknown",
}

export enum Validator {
    AxeCore = "axe-core",
}

export interface ValidationMessageNode {
    selector?: CrossTreeSelector;
    innerHtml: string;
}

export interface AccessibilityValidationMessage {
    id: string;
    message: string;
    description?: string;
    impact: ValidationMessageImpact;
    nodes: ValidationMessageNode[];
    validator?: Validator;
    originalMessage?: unknown;
    url: string;
}
